export default {
  getTranslations: state => state.translations,
  getTranslationByOperatorIfExists: state => (ordinal, key) => {
    const indexKey = (ordinal ? `${key}.${ordinal}` : key);
    return state.translations[indexKey];
  },
  getTranslationByOperator: state => (ordinal, key) => {
    const indexKey = (ordinal ? `${key}.${ordinal}` : key);
    return state.translations[indexKey] || state.translations[key];
  },
  getLocale: state => state.currentLocale,
  getDefaultLanguage: state => state.defaultLanguage,
  getDisplayedLocale: state => state.availableLocales[state.currentLocale],
  getTranslationsKeys: state => Object.keys(state.translations),
  getTranslationTestimonial: state => (ordinal, key) => {
    const indexKey = `${key}${ordinal}`;
    return state.translations[indexKey];
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/i18n/getters.js